import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { ReactComponent as WarningIcon } from '../../assets/warning-tip.svg';
import ModalDialog from '../modal-dialog/modal-dialog.component';
import { VerifyPhoneNumberContent } from './styles';
import { useModal } from '../modal';
import { Modals } from '../../constants/modals';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const ModalVerifyPhoneNumber = ({ isOpen, onClose }: Props) => {
  const { t } = useTranslation();
  const { enqueueModalNext } = useModal();

  const handleVerify = () => {
    enqueueModalNext({
      id: Modals.USER_SETTINGS_PHONE_VERIFICATION,
      name: Modals.USER_SETTINGS_PHONE_VERIFICATION,
      props: {
        phoneNumberInputRequired: true,
      },
    });
    onClose();
  };

  return (
    <ModalDialog
      isOpen={isOpen}
      onClose={onClose}
      onApprove={handleVerify}
      approveBtnContent={t('verify_phone_number_modal_verify')}
      cancelBtnContent={t('verify_phone_number_modal_not_now')}
      width='60rem'
      padding='3.2rem'
      buttonsGap='1.2rem'
      boxShadow='0 2px 8px rgba(5, 35, 107, 0.08)'>
      <VerifyPhoneNumberContent>
        <div className='header'>
          <WarningIcon className='warningIcon' />
          <h2>{t('verify_phone_number_modal_title')}</h2>
        </div>
        <p>{t('verify_phone_number_modal_description')}</p>
      </VerifyPhoneNumberContent>
    </ModalDialog>
  );
};

export default observer(ModalVerifyPhoneNumber);
